import React, { Component } from "react";
import Welcome from "./Welcome";
import Whatson from "./Whatson";
import Header from "./Header";
class Home extends Component {
  render() {
    return (
      <div>
      <Header>
      </Header>
      <Welcome>
      </Welcome>
      <Whatson>
      </Whatson>
      <div className="Hit"> 
      <tr>
      <td>
      <b>Hi score? Ours is </b> 
      <a href="http://www.hitwebcounter.com/links.php">
      <img src="http://hitwebcounter.com/counter/counter.php?page=5107219&style=0025&nbdigits=9&type=page&initCount=23675076" alt="hitctr" border="0"/></a>
       <b> and counting...</b>
      </td>
    </tr>
</div>
      </div>
    );
  }
}
 
export default Home;



// WEBPACK FOOTER //
// ./src/Home.js